module.exports = __webpack_public_path__ + "static/media/victory.0cc5ca0c.png";